import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";

import ProtectedRoute from "./utils/ProtectedRoute";
// pages
// auth
import {
  Login,
  Signup,
  AuthOtp,
  ForgetPassword,
  ResetPassword,
} from "./pages/auth";
// admin
import {
  Dashboard,
  ListUser,
  FormUser,
  ListRole,
  FormRole,
  ListFakultas,
  FormFakultas,
  ListLayanan,
  FormLayanan,
  ListProdi,
  FormProdi,
  ListDokumen,
  FormDokumen,
  ListKodepayVAPeriod,
  ListKodepayVA,
  FormKodepayVA,
  ListStaffMenu,
  FormStaffMenu,
  ListJenisPembiayaan,
  FormJenisPembiayaan,
  ListSurvey,
  FormSurvey,
  ListUserDiscount,
  FormUserDiscount,
} from "./pages/admin";
import { Profile, ProfilePassword } from "./pages/profile";
// Pembayaran Va
import {
  ListPembayaranVAPage,
  FormPembayaranVAPage,
  ReportPembayaranVAPage,
  OverviewPembayaranVAPage,
} from "./pages/transaction/PembayaranVA";

import { router } from "./routes";

import {
  FormPermohonanPage,
  ListPermohonanPage,
  ReportPermohonanPage,
  OverviewPermohonanPage,
} from "./pages/transaction/Permohonan";
import {
  FormPraktikumPage,
  ListPraktikumPage,
  OverviewPraktikumPage,
  ReportPraktikumPage,
} from "./pages/transaction/Praktikum";
import {
  FormCashflowPage,
  ListCashflowPage,
  OverviewCashflowPage,
  ReportCashflowPage,
} from "./pages/transaction/Cashflow";
import {
  ListImportMutasiBankPage,
  FormImportMutasiBankPage,
} from "./pages/transaction/ImportMutasiBank";
import {
  DetailSurveyUserPage,
  FormAnswerPage,
  ListSurveyUserPage,
  OverviewSurveyUserPage,
} from "./pages/transaction/SurveyUser";
import ConfigSemesterPage from "./pages/config/ConfigSemesterPage";
import {
  ListMadingPage,
  FormMadingPage,
  ViewMadingPage,
} from "./pages/transaction/Mading";

const App = () => {
  const rolesAdminOnly = ["HA01"];
  const rolesDekan = ["HA01", "HA02"];
  const rolesDekanTU = ["HA01", "HA02", "HA04"];
  const rolesTU = ["HA01", "HA04"];
  const rolesTUMahasiswa = ["HA01", "HA04", "HA05"];
  const rolesMahasiswa = ["HA01", "HA05"];

  return (
    <BrowserRouter>
      <Routes>
        {/* Admin route */}
        <Route
          path={router.Dashboard.path}
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        {/* Master Role */}
        <Route
          path={router.ListRole.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <ListRole />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.ViewRole.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormRole />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.AddRole.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormRole />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.EditRole.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormRole />
            </ProtectedRoute>
          }
        />

        {/* Master Layanan */}
        <Route
          path={router.ListLayanan.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <ListLayanan />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.AddLayanan.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormLayanan />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.EditLayanan.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormLayanan />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.ViewLayanan.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormLayanan />
            </ProtectedRoute>
          }
        />

        {/* Master Jenis Pembiayaan */}
        <Route
          path={router.ListJenisPembiayaan.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <ListJenisPembiayaan />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.AddJenisPembiayaan.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormJenisPembiayaan />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.EditJenisPembiayaan.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormJenisPembiayaan />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.ViewJenisPembiayaan.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormJenisPembiayaan />
            </ProtectedRoute>
          }
        />

        {/* Master Prodi */}
        <Route
          path={router.ListProdi.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <ListProdi />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.ViewProdi.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormProdi />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.AddProdi.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormProdi />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.EditProdi.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormProdi />
            </ProtectedRoute>
          }
        />
        {/* Master Mahasiswa */}
        <Route
          path={router.ListUser.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <ListUser />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.GetUserId.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormUser />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.EditUser.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormUser />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.AddUser.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormUser />
            </ProtectedRoute>
          }
        />
        {/* Master menu */}
        <Route
          path={router.ListStaffMenu.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <ListStaffMenu />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.AddStaffMenu.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormStaffMenu />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.ViewStaffMenu.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormStaffMenu />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.EditStaffMenu.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormStaffMenu />
            </ProtectedRoute>
          }
        />
        {/* Master User Discount */}
        <Route
          path={router.ListUserDiscount.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <ListUserDiscount />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.AddUserDiscount.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormUserDiscount />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.ViewUserDiscount.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormUserDiscount />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.EditUserDiscount.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormUserDiscount />
            </ProtectedRoute>
          }
        />
        {/* Dokumen */}
        <Route
          path={router.ListDokumen.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <ListDokumen />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.AddDokumen.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormDokumen />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.EditDokumen.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormDokumen />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.ViewDokumen.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormDokumen />
            </ProtectedRoute>
          }
        />
        {/* Fakultas */}
        <Route
          path={router.ListFakultas.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <ListFakultas />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.AddFakultas.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormFakultas />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.EditFakultas.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormFakultas />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.ViewFakultas.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormFakultas />
            </ProtectedRoute>
          }
        />

        {/* Kode payment VA*/}
        <Route
          path={router.ListKodepayment.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <ListKodepayVAPeriod />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.ListKodepaymentDetail.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <ListKodepayVA />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.AddKodepayment.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormKodepayVA />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.EditKodepayment.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormKodepayVA />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.ViewKodepayment.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormKodepayVA />
            </ProtectedRoute>
          }
        />

        {/* VA Payment */}
        <Route
          path={router.ListPembayaranVA.path}
          element={
            <ProtectedRoute roles={rolesTUMahasiswa}>
              <ListPembayaranVAPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.DetailPembayaranVA.path}
          element={
            <ProtectedRoute roles={rolesTUMahasiswa}>
              <FormPembayaranVAPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.CreatePembayaranVA.path}
          element={
            <ProtectedRoute roles={rolesTUMahasiswa}>
              <FormPembayaranVAPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.EditPembayaranVA.path}
          element={
            <ProtectedRoute roles={rolesTUMahasiswa}>
              <FormPembayaranVAPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.ReportPembayaranVA.path}
          element={
            <ProtectedRoute roles={rolesTU}>
              <ReportPembayaranVAPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.OverviewPembayaranVA.path}
          element={
            <ProtectedRoute roles={rolesTU}>
              <OverviewPembayaranVAPage />
            </ProtectedRoute>
          }
        />
        {/* END VA PAYMENT */}

        {/* PERMOHONAN */}
        <Route
          path={router.ListPermohonan.path}
          element={
            <ProtectedRoute roles={rolesTUMahasiswa}>
              <ListPermohonanPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.DetailPermohonan.path}
          element={
            <ProtectedRoute roles={rolesTUMahasiswa}>
              <FormPermohonanPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.CreatePermohonan.path}
          element={
            <ProtectedRoute roles={rolesTUMahasiswa}>
              <FormPermohonanPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.EditPermohonan.path}
          element={
            <ProtectedRoute roles={rolesTUMahasiswa}>
              <FormPermohonanPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.ReportPermohonan.path}
          element={
            <ProtectedRoute roles={rolesTU}>
              <ReportPermohonanPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.OverviewPermohonan.path}
          element={
            <ProtectedRoute roles={rolesTU}>
              <OverviewPermohonanPage />
            </ProtectedRoute>
          }
        />
        {/* END PERMOHONAN */}

        {/* PRAKTIKUM */}
        <Route
          path={router.ListPraktikum.path}
          element={
            <ProtectedRoute roles={rolesTUMahasiswa}>
              <ListPraktikumPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.DetailPraktikum.path}
          element={
            <ProtectedRoute roles={rolesTUMahasiswa}>
              <FormPraktikumPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.CreatePraktikum.path}
          element={
            <ProtectedRoute roles={rolesTUMahasiswa}>
              <FormPraktikumPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.EditPraktikum.path}
          element={
            <ProtectedRoute roles={rolesTUMahasiswa}>
              <FormPraktikumPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.ReportPraktikum.path}
          element={
            <ProtectedRoute roles={rolesTU}>
              <ReportPraktikumPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.OverviewPraktikum.path}
          element={
            <ProtectedRoute roles={rolesTU}>
              <OverviewPraktikumPage />
            </ProtectedRoute>
          }
        />
        {/* END PRAKTIKUM */}

        {/* CASHFLOW */}
        <Route
          path={router.ListCashflow.path}
          element={
            <ProtectedRoute roles={rolesDekan}>
              <ListCashflowPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.DetailCashflow.path}
          element={
            <ProtectedRoute roles={rolesDekan}>
              <FormCashflowPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.CreateCashflow.path}
          element={
            <ProtectedRoute roles={rolesDekan}>
              <FormCashflowPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.EditCashflow.path}
          element={
            <ProtectedRoute roles={rolesDekan}>
              <FormCashflowPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.ReportCashflow.path}
          element={
            <ProtectedRoute roles={rolesDekan}>
              <ReportCashflowPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.OverviewCashflow.path}
          element={
            <ProtectedRoute roles={rolesDekan}>
              <OverviewCashflowPage />
            </ProtectedRoute>
          }
        />
        {/* END CASHFLOW */}

        {/* MADING */}
        <Route
          path={router.ListMading.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <ListMadingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.DetailMading.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormMadingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.CreateMading.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormMadingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.EditMading.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <FormMadingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.ViewMading.path}
          element={
            <ViewMadingPage />
          }
        />
        {/* END MADING */}

        {/* SURVEY USER */}
        <Route
          path={router.InsertSurveyUser.path}
          element={
            <ProtectedRoute>
              <FormAnswerPage />
            </ProtectedRoute>
          }
        />
        {/* END SURVEY USER */}

        {/* PROFILE PAGE */}
        <Route
          path={router.Profile.path}
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.ProfilePassword.path}
          element={
            <ProtectedRoute>
              <ProfilePassword />
            </ProtectedRoute>
          }
        />
        {/* END PROFILE */}

        {/* MASTER SURVEY */}
        <Route
          path={router.ListSurvey.path}
          element={
            <ProtectedRoute roles={rolesTU}>
              <ListSurvey />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.ViewSurvey.path}
          element={
            <ProtectedRoute roles={rolesTU}>
              <FormSurvey />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.AddSurvey.path}
          element={
            <ProtectedRoute roles={rolesTU}>
              <FormSurvey />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.EditSurvey.path}
          element={
            <ProtectedRoute roles={rolesTU}>
              <FormSurvey />
            </ProtectedRoute>
          }
        />
        {/* END MASTER SURVEY */}

        {/* SURVEY USER */}
        <Route
          path={router.ListSurveyUser.path}
          element={
            <ProtectedRoute roles={rolesTU}>
              <ListSurveyUserPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.ViewSurveyUser.path}
          element={
            <ProtectedRoute roles={rolesTU}>
              <DetailSurveyUserPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.OverviewSurveyUser.path}
          element={
            <ProtectedRoute roles={rolesTU}>
              <OverviewSurveyUserPage />
            </ProtectedRoute>
          }
        />
        {/* END SURVEY USER */}

        {/* IMPORT MUTASI BANK */}
        <Route
          path={router.ListImportMutasiBank.path}
          element={
            <ProtectedRoute roles={rolesDekan}>
              <ListImportMutasiBankPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={router.ViewImportMutasiBank.path}
          element={
            <ProtectedRoute>
              <FormImportMutasiBankPage roles={rolesDekan} />
            </ProtectedRoute>
          }
        />
        {/* END IMPORT MUTASI BANK */}

        {/* IMPORT MUTASI BANK */}
        <Route
          path={router.ViewConfigSemester.path}
          element={
            <ProtectedRoute roles={rolesAdminOnly}>
              <ConfigSemesterPage />
            </ProtectedRoute>
          }
        />
        {/* END IMPORT MUTASI BANK */}

        {/* Auth route */}
        <Route path={router.ForgetPassword.path} element={<ForgetPassword />} />
        <Route path={router.ResetPassword.path} element={<ResetPassword />} />
        <Route path="/verification" element={<AuthOtp />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/signin" element={<Login />} />
        <Route path="/" element={<PivotComponent />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

function PivotComponent() {

  const navigate = useNavigate();

  useEffect(() => {
    const userData = localStorage.getItem("userData");

    if (userData) {
      if (JSON.parse(userData).status === "0") {
        navigate("/verification");
      } else if (JSON.parse(userData).status === "1") {
        navigate("/dashboard");
      }
    } else {
      navigate("/signin");
    }
  }, []);

  return (
    <div className={`centerAbsolute`}>
      <h1>404 - Not Found</h1>
      <p>Sorry, the page you are looking for does not exist.</p>
    </div>
  );
}

function NotFound() {
  return (
    <div className={`centerAbsolute`}>
      <h1>404 - Not Found</h1>
      <p>Sorry, the page you are looking for does not exist.</p>
    </div>
  );
}

export default App;
